const setOriginImageSize = (imageNode, { width = '', height = '' }) => {
  if (!imageNode) throw new Error('Image node of type Node Element should be provided');

  imageNode.setAttribute('origin-width', width);
  imageNode.setAttribute('origin-height', height);
};

export default setOriginImageSize;
